import { FC, useEffect, useRef, useState } from "react";
import { Accordion } from "../../../../components/controls/accordion";
import GridSelectorInput from "../../../../components/controls/GridSelectorInput";
import GridWrapper from "../../../../components/controls/GridWrapper";
import { DateInput, NumberInput, TextAreaInput, TextInput } from "../../../../components/controls/inputs";
import BaseDocumentCreator from "../../../../components/documents/baseDocumentCreator";
import { ICostInfoDTO, IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import { PricingModelSelectorModal } from "../../../Dictionaries/PricingModel";
import styles from "../styles/ActRevaluation.module.scss";
import { v4 as uuidv4,  NIL as uuidNull } from "uuid";
import { Button } from "../../../../components/buttons/button";
import { IOption, Select } from "../../../../components/selects/select";
import { SettingsButtonModal } from "../../../../components/buttons/iconButtons/settingsButton/SettingsButtonModal";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { IDocumentUpdateFormProps } from "../../../../@types/documents";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { useTranslation } from "react-i18next";
import RevaluationItemGridPluginSettings from "./RevaluationItemGridPluginSettings";
import { LotsSelectorModal } from "../../../Accounting/Lots";
import { ILotDTO, ILotViewDTO } from "../../../../libs/coreapi-dto/accounting/lot";
import { LotDataProvider } from "../../../../Services/DataProviders/LotDataProvider";
import { DateTime } from "luxon";
import { useForm } from "../../../../system/hooks/useForm";
import { CheckBox } from "../../../../components/controls/checkbox";
import { StoreDataProvider } from "../../../../Services/DataProviders/StoreDataProvider";
import { ActRevaluationItemCreateModal } from "./ActRevaluationCreatorItem/ActRevaluationItemCreateModal";
import KizScanModal from "../../../Dictionaries/Kiz/ScanModal/KizScanModal";
import { IActRevaluationItemCreateDTO, IActRevaluationItemEditDTO, IActRevaluationItemGetDTO } from "../../../../libs/coreapi-dto/documents/ActRevaluationItem";
import { ActRevaluationRemnantsType, IActRevaluationCreateDTO, IActRevaluationFillWithRemnantsOnStoreDto, IActRevaluationFillWithRemnantsOnStoreResponse, IActRevaluationFromSingleStoreResponse, IActRevaluationGetDTO, IActRevaluationUpdateDTO } from "../../../../libs/coreapi-dto/documents/ActRevaluation";
import { IKeyValuePair } from "../../../Reports/Shared/Interfaces/IKeyValuePair";
import { ActRevaluationItemUpdateModal } from "./ActRevaluationCreatorItem/ActRevaluationItemUpdateModal";
import { DocumentStateType, DocumentType, IdTableVariant, SearchOption, TaxTypesOptions } from "../../../../@types/enumsGlobal";
import { ILotsByIdDTO } from "../../../../libs/core-api-requests/accounting/lotRequest";
import LotsSimpleSelectorModal from "../../../Accounting/Lots/LotsSimpleSelectorModal";
import PositionEditPanel from "../../../../components/commandsPanels/PositionEditPanel";
import { ScalingRatioDataProvider } from "../../../../Services/DataProviders/ScalingRatioDataProvider";
import { IScalingRatioDTO } from "../../../../libs/coreapi-dto/dirs/scalingRatio";
import { autocomplete } from "../../../../system/functions/autocomplete";
import { BtSaveOrOk } from "../../Invoice/InvoiceCreator/InvoiceUpdateForm";
import { MessageModalWindow } from "../../../../components/modalWindows/MessageModalWindow";
import { getStyleCell } from "../../../../system/functions/getStyleCell";
import { controlKiz, countKizSum } from "../../../../system/functions/controlKiz";
import { ChangeableGrid, IChangeDataGrid } from "../../../../components/grids/changeableGrid/ChangeableGrid";
import { PricingRevaluationDataProvider } from "../../../../Services/DataProviders/PricingRevaluationDataProvider";
import { ICostInfo, IPricingDocumentItemDTO, IPricingRevaluationItemResultDTO } from "../../../../libs/coreapi-dto/dirs/pricingInvoice";
import { addKizOrKizBox } from "../../../../system/functions/addKizOrKizBox";
import { BarcodeType, IKizBoxDTO, IKizDTO } from "../../../../libs/coreapi-dto/dirs/kiz";
import renderGlobalAlert from "../../../../system/hooks/useGlobalAlert";
import { KizDataProvider } from "../../../../Services/DataProviders/KizDataProvider";
import { DictionaryInput } from "../../../../components/controls/dictionaryInput";
import { SelectDocumentModalWindow } from "../../../../components/modalWindows/SelectDocumentModalWindow";
import { addValueToArray } from "../../../../system/functions/addValToArray";
import useOperativeReserve from "../../../../components/lotSelector/useOperativeReserve";
import { StoreSelectorPanel } from "../../../../components/storeSelectorPanel";
import { onCanChangeData } from "../../../../system/functions/onCanChangeData";
import { onPharmacyChanged } from "../../../../system/functions/onPharmacyChanged";
import { checkStorePharmacy } from "../../../../system/functions/checkStorePharmacy";
import { useTimeout } from "../../../../system/hooks/useTimeout";
import { useComPortScanner } from "../../../../system/hooks/useHubConnection";
import useLockingDocuments from "../../../../components/lockDocuments/useLockingDocuments";
import { MoneyFormatComponent } from "../../../../components/controls/inputs/BaseInput";
import { useUserContext } from "../../../../system/providers/userContextProvider";
import { checkLockStatus } from "../../../CommonHelperFunctions";
import { useTabsContext } from "../../../../system/providers/tabsProvider";
import FlexRow from "../../../../components/controls/FlexRow";
import { KizParsed } from "../../../Dictionaries/Kiz/KizParsed";
import { KizBoxEntity } from "../../../Dictionaries/Kiz/KizBoxEntity";
import { validateDuplicateKizs } from "../../../../system/functions/validateDuplicateKizs";
import buffer from "buffer";
import { ProgressActionSpinner } from "../../../../components/progressActionSpinner/ProgressActionSpinner";
import { PricingModelDataProvider } from "../../../../Services/DataProviders/PricingModelDataProvider";
import { IPricingModelDTO } from "../../../../libs/coreapi-dto/dirs/pricingModel";
import { fillDisplayItemWithCellValue } from "../../../../system/functions/fillDisplayItemWithCellValue";
import { IPricingRevaluationItem, IPricingRevaluationItemDTO, IPricingRevaluationSingleItem } from "../../../../libs/coreapi-dto/dirs/pricingRevaluation";
import { ActRevaluationRecalcModal, AdjustmentFactorType, IMarkupOrMarkdownState, PriceAdjustmentMethod, PriceAdjustmentType } from "./ActRevaluationRecalcModal";
import { IButton } from "../../../../components/modalWindows/BaseModalWindow";
import { ActRevaluationDataProvider } from "../../../../Services/DataProviders/ActRevaluationDataProvider";
import { DeleteModalWindow } from "../../../../components/modalWindows/DeleteModalWindow";
import { IStoreDTO } from "../../../../libs/coreapi-dto/dirs/store";
import { ILotsViewItem } from "../../../Accounting/Lots/LotsSelector";

interface ICreatorItem {
    lot: ILotDTO | null;
    show: boolean;
    editItem?: IActRevaluationItemEditDTO | null;
}

interface IValidator {
    store: IEntitySimpleDTO;
    pricingModel: IEntitySimpleDTO;
    documentDate: DateTime;
}

export interface IDisplayItem {
    idGlobal: string;
    idLotGlobal: string;
    goodsName: string;
    goodsCode: string,
    producer: string,
    storeName: string;
    retailPriceIncVat: number;
    retailPriceIncVatOld?: number;
    retailAdpriceOld?: number
    retailAdprice: number
    retailSumIncVat: number;
    quantity: number;
    isKiz: boolean;
    isGnvls: boolean;
    countKizScan: number | undefined;
    supplier?: string;
    dateCreated: DateTime;
    isOsu?: boolean
    actualPrice?: number
}

export interface ICreateItem {
    item: IActRevaluationItemCreateDTO;
    displayItem: IDisplayItem;
    goodsInfo: IGoodsInfo;
}
export interface IGoodsInfo {
    idGoods: string;
    idScalingRatio: string;
    idGlobal: string;
}

interface IMessageModalProps {
    show: boolean;
    message: string;
    btSaveOrOk?: BtSaveOrOk;
}

interface IBaseFields {
    pharmacy: IEntitySimpleDTO;
    store: IEntitySimpleDTO;
    pricingModel: IEntitySimpleDTO;
    storeFromLot: IEntitySimpleDTO;
}

interface IReturnCreatedItem {
    createdItem: IActRevaluationItemCreateDTO;
    displayItem: IDisplayItem;
}

interface ISum {
    amountSupplierSum: number,
    amountSupplierVatSum: number,
    amountSupplierSumIncVat: number,
    amountRetailSum: number,
    amountRetailVatSum: number,
    amountRetailSumIncVat: number
}

//interface IActRevaluationFillWithRemainedLotsDto {
//    readonly docDate?: DateTime;
//    readonly fillOnlyKiz: boolean | null;
//}

export const TaxRatesByType: { [key: string]: number } = {
    "НДС 0%": 0,
    "НДС 5%": 5,
    "НДС 7%": 7,
    "НДС 10%": 10,
    "НДС 20%": 20,
    "НДС 22%": 22
}

export const ActRevaluationForm: FC<IDocumentUpdateFormProps<IActRevaluationGetDTO, IActRevaluationItemGetDTO[], IActRevaluationUpdateDTO>> = (props) => {

    const appContext = useAppContext();
    const userContext = useUserContext();

    // DP
    const lotDP = new LotDataProvider(appContext.coreApiService);
    const operativeReserve = useOperativeReserve();
    const storeDP = new StoreDataProvider(appContext.coreApiService);
    const scalingRatioDP = new ScalingRatioDataProvider(appContext.coreApiService);
    const pricingRevaluationDP = new PricingRevaluationDataProvider(appContext.coreApiService);
    const pricingModelDP = new PricingModelDataProvider(appContext.coreApiService);
    const kizDP = new KizDataProvider(appContext.coreApiService);
    const actRevaluationDP = new ActRevaluationDataProvider(appContext.coreApiService);

    const lockFromPermission = checkLockStatus(props.permission as IPermission, userContext.userPermission);
    const [onlyRead, setOnlyRead] = useState((props.variant === 'edit' && (props.document?.documentState === 'proc' || lockFromPermission)) ? true : false);
    const [showMessageModalValidDocument, setShowMessageModalValidDocument] = useState<IMessageModalProps>({ show: false, message: "" });
    const idTable = IdTableVariant.ActRevaluation2
    const lockingDocuments = useLockingDocuments();
    const [idLockingDocument, setIdLockingDocument] = useState<string|undefined>();
    const [pricingModelDto, setPricingModelDto] = useState<IPricingModelDTO>()
    
    const [sum, setSum] = useState<ISum>({
        amountSupplierSum: 0,
        amountSupplierVatSum: 0,
        amountSupplierSumIncVat: 0,
        amountRetailSum: 0,
        amountRetailVatSum: 0,
        amountRetailSumIncVat: 0
    });

    const [data, setData] = useState<IActRevaluationCreateDTO>(
        props.documentUpdate ??
            ({
                idGlobal: props.idGlobal,
                documentDate: DateTime.now(),
                items: [] as IActRevaluationItemCreateDTO[],
            } as IActRevaluationCreateDTO)
    );
    //const [totalCount, setTotalCount] = useState(0);
    const [displayItems, setDisplayItems] = useState<IDisplayItem[]>(
      
        props.documentItems
            ? [
                  ...props.documentItems.map((x: IActRevaluationItemGetDTO, index): IDisplayItem => {
                      return {
                          idGlobal: x.idGlobal,
                          retailAdpriceOld: x.retailAdpriceOld,
                          retailPriceIncVatOld: x.retailPriceIncVatOld,
                          goodsName: x.goods.displayName,
                          idLotGlobal: x.lot.idGlobal,
                          goodsCode: x.goodsCode,
                          producer: x.producer,
                          storeName: props.document?.store.displayName ?? "",
                          retailPriceIncVat: x.retailCostInfo.priceIncVat,
                          retailSumIncVat: x.retailCostInfo.sumIncVat,
                          retailAdprice: x.retailCostInfo.adprice,
                          quantity: x.quantity,
                          isGnvls: x.isGnvls ?? false,
                          isKiz: x.isKiz,
                          countKizScan: x.isKiz === true ? x.kizCount + x.kizBoxCount: undefined,
                          supplier: x.supplier,
                          dateCreated: x.dateCreated,
                          isOsu: x?.kizOsuDto?.barcode !== undefined,
                          actualPrice: x.actualPrice
                      };
                  }),
              ]
            : []
    );
    const [baseFields, setBaseFields] = useState<IBaseFields>({
        pharmacy: {} as IEntitySimpleDTO,
        store: {} as IEntitySimpleDTO,
        pricingModel: { idGlobal: props.document?.pricingModel?.idGlobal, displayName: props.document?.pricingModel?.displayName } as IEntitySimpleDTO,
        storeFromLot: {} as IEntitySimpleDTO,
    });

    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [displayNameBaseDoc, setDisplayNameBaseDoc] = useState<string>("");
    const [showMessageModalValidBaseDocument, setShowMessageModalValidBaseDocument] = useState<boolean>(false);

    const [creatorItem, setCreatorItem] = useState<ICreatorItem>({ lot: null, show: false, editItem: null });

    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [gridFilterLot, dispatchGridFilterLot] = useGridFilter();

    const [showKizScan, setShowKizScan] = useState<boolean>(false);
    const [lotsViewItem, setLotsViewItem] = useState<ILotsViewItem>({ item: null, show: false, multiple: true });
    const [showMessageModal, setShowMessageModal] = useState<IMessageModalProps>({ show: false, message: "" });

    const [selectedScalingRatio, setSelectedScalingRatio] = useState<IScalingRatioDTO | null>(null);

    const [selectBaseDocument, setSelectBaseDocument] = useState<boolean>(false);

    const { t } = useTranslation();
    const baseT = (value: string) => t("documents.actRevaluation." + value);
    const errorsT = (value: string) => t("errors." + value);

    const defaultSearchOption = {displayName: t("documents.movement.goodsName"), value: SearchOption.goodsName} as IOption;
    const [searchOption, setSearchOption] = useState<IOption>(defaultSearchOption);
    const [scanData, setScanData] = useState<string>("");

    const [selectedItemCreateDto, setSelectedItemCreateDto] = useState<IActRevaluationItemCreateDTO>();
    const [scanFocus, setScanFocus] = useState<boolean>(false);
    const [scanValue, setScanValue] = useState<string>("");
    const timeout = useRef<NodeJS.Timeout>();
    const scanner = useComPortScanner((scanData: string) => {

        if (showKizScan && selectedScalingRatio) return

        const decodedText = atob(scanData);

        let kizParsed = new KizParsed(decodedText)
        const encodedGtinSgtin = encodeURIComponent(kizParsed.gtinSgtin);
        const encodedDecodedText = encodeURIComponent(decodedText);

        if (kizParsed.isKiz) {
            const idStoreGlobal: string | null = data?.idStoreGlobal ?? null;
            lotDP.getListLotByGtinSgtin(encodedGtinSgtin, idTable as number, idStoreGlobal, (lots: ILotsByIdDTO[]) => {
                if (lots.length > 1) {
                    setLotsViewItem(
                        { 
                            item: lots, 
                            show: true, 
                            multiple: false, 
                            queryArg: encodedDecodedText, 
                            handleLot: handleLotSelect 
                        });
                    return;
                }

                const singleLot = lots[0];
                setScanData(encodedDecodedText)
                handleLotSelect(singleLot, encodedDecodedText)
            })
        }
    });

    // Validations
    const [itemsValidation, setItemsValidation] = useState<IValidationItem[]>([]);
    const [itemsFilter, setItemsFilter] = useState<IItemFilter[]>([]);
    const [setTimer, clearTimer] = useTimeout();

    const [modalWindow, setModalWindow] = useState(<></>);
    //const [sendRequestDocumentItems, setSendRequestDocumentItems] = useState<boolean>(false);

    const tabsContext = useTabsContext();
    const currentIdTab = useRef<string>('');

    const [requiredScanKiz, setRequiredScanKiz] = useState<boolean>(true);

    const fillRevaluationItemWithPricingValues = (pricingItem: IPricingDocumentItemDTO, value: IChangeDataGrid) => {
        const propertyName = value.propertyName.toLowerCase();
        const isQuantityChanged = propertyName === "quantity";
        const isRetailAdpriceChanged = propertyName === "retailadprice";

        setData((prev) => ({
            ...prev,
            items: prev.items.map((item) => {
                if (item.idGlobal !== value.idGlobal) return item;

                const retailAdprice = isQuantityChanged
                    ? item.retailCostInfo.adprice
                    : isRetailAdpriceChanged
                        ? Number(value.value)
                        : pricingItem.percentageOfMarkupRetail;

                return {
                    ...item,
                    retailCostInfo: {
                        vat: pricingItem.percentageOfVatRateRetail,
                        price: pricingItem.retailPrice,
                        vatPrice: pricingItem.retailVatPerUnit,
                        priceIncVat: pricingItem.retailPriceWithVat,
                        sum: pricingItem.retailAmount,
                        vatSum: pricingItem.vatAmountRetail,
                        sumIncVat: pricingItem.retailAmountWithVat,
                        adprice: retailAdprice,
                    } as ICostInfoDTO,
                    supplierCostInfo: {
                        vat: pricingItem.supplierVatRatePercentage,
                        price: pricingItem.supplierPriceExcludingVat,
                        vatPrice: pricingItem.supplierVatPerUnit,
                        priceIncVat: pricingItem.supplierPriceWithVat,
                        sum: pricingItem.supplierAmountExcludingVat,
                        vatSum: pricingItem.supplierVatAmount,
                        sumIncVat: pricingItem.supplierAmountWithVat,
                        adprice: pricingItem.supplierMarkupPercentage,
                    } as ICostInfoDTO,
                    quantity: pricingItem.quantity,
                };
            }),
        }));

        setDisplayItems((prev) =>
            prev.map((item) => {
                if (item.idGlobal !== value.idGlobal) return item;

                const retailAdprice = isQuantityChanged
                    ? item.retailAdprice
                    : isRetailAdpriceChanged
                        ? Number(value.value)
                        : pricingItem.percentageOfMarkupRetail;

                return {
                    ...item,
                    retailPriceIncVat: pricingItem.retailPriceWithVat,
                    retailSumIncVat: pricingItem.retailAmountWithVat,
                    retailAdprice: retailAdprice * 1,
                    quantity: pricingItem.quantity,
                };
            })
        );
    }

    const calculateBatch = (calcItems: IPricingRevaluationItemDTO[], callbackFinally?: () => void) => {

        if (!calcItems || calcItems.length === 0)
            return;

        renderProgressView("Пересчёт документа");

        pricingRevaluationDP.calculateBatch(data.idPricingModelGlobal, calcItems,
            (resultItems: IPricingRevaluationItemResultDTO[]) => {
                if (resultItems.length && resultItems.length === calcItems.length) {

                    // Обновление стейтов на основе resultItems
                    const resultMap = new Map<string, IPricingRevaluationItemResultDTO>();
                    resultItems.forEach(result => {
                        resultMap.set(result.idGlobal, result);
                    });

                    // Обновляем data.items
                    const updatedDataItems = data.items.map(item => {
                        const result = resultMap.get(item.idGlobal);
                        if (result) {
                            // Аналогично fillRevaluationItemWithPricingValues
                            return {
                                ...item,
                                retailCostInfo: {
                                    vat: result.percentageOfVatRateRetail,
                                    price: result.retailPrice,
                                    vatPrice: result.retailVatPerUnit,
                                    priceIncVat: result.retailPriceWithVat,
                                    sum: result.retailAmount,
                                    vatSum: result.vatAmountRetail,
                                    sumIncVat: result.retailAmountWithVat,
                                    adprice: result.percentageOfMarkupRetail,
                                } as ICostInfoDTO,
                                supplierCostInfo: {
                                    vat: result.supplierVatRatePercentage,
                                    price: result.supplierPriceExcludingVat,
                                    vatPrice: result.supplierVatPerUnit,
                                    priceIncVat: result.supplierPriceWithVat,
                                    sum: result.supplierAmountExcludingVat,
                                    vatSum: result.supplierVatAmount,
                                    sumIncVat: result.supplierAmountWithVat,
                                    adprice: result.supplierMarkupPercentage,
                                } as ICostInfoDTO,
                                quantity: result.quantity,
                            };
                        }

                        console.warn(`Результат пересчета не найден для idGlobal: ${item.idGlobal}`);
                        return item;
                    });

                    // Обновляем displayItems
                    const updatedDisplayItems = displayItems.map(displayItem => {
                        const result = resultMap.get(displayItem.idGlobal);
                        if (result) {
                            // Аналогично fillRevaluationItemWithPricingValues
                            return {
                                ...displayItem,
                                retailPriceIncVat: result.retailPriceWithVat,
                                retailSumIncVat: result.retailAmountWithVat,
                                retailAdprice: result.percentageOfMarkupRetail * 1,
                                quantity: result.quantity,
                            };
                        }

                        console.warn(`Результат пересчета не найден для idGlobal: ${displayItem.idGlobal}`);
                        return displayItem;
                    });

                    // Устанавливаем обновленные стейты
                    setData({
                        ...data,
                        items: updatedDataItems,
                    });
                    setDisplayItems(updatedDisplayItems);

                    callbackFinally?.()
                    setModalWindow(<></>)
                } else {
                    renderGlobalAlert({
                        variant: "warning",
                        title: "Результат пересчета не совпадает количественно с составом документа",
                        statusCode: 0
                    })
                }

            },
            null,
            (err: string) => {
                setModalWindow(<></>)
                renderGlobalAlert({
                    variant: "warning",
                    title: err,
                    statusCode: 0,
                });
            })
    }

    const calculateItem = (calcItem: IPricingRevaluationItemDTO, cell: IChangeDataGrid, callbackFinally?: () => void, renderAlerts: boolean = true) => {
        
        // Установка введеного значения превентивно
        // В последующем пересчёт может вернуть предыдущие актуальные значения измененных данных
        // Требуется для корректного отображения рассчитанных полей
        fillDisplayItemWithCellValue(cell, ["retailAdprice", "retailPriceIncVat"] as const, setDisplayItems);

        pricingRevaluationDP.calculateItem(data.idPricingModelGlobal, calcItem,
            (revaluationItemResult: IPricingRevaluationItemResultDTO) => {
                if (revaluationItemResult.retailPriceChangeReason && revaluationItemResult.retailPriceChangeReason.length > 0 && renderAlerts) {
                    renderGlobalAlert({
                        variant: revaluationItemResult.retailPriceChangeReason.includes("[Info]") ? "info" : "warning",
                        title: revaluationItemResult.retailPriceChangeReason.replace("[Info]", ""),
                        statusCode: 0,
                    });
                }

                // Обновить айтем
                fillRevaluationItemWithPricingValues(revaluationItemResult, cell);
                callbackFinally?.();
            },
            null,
            (err: string) => {

                renderGlobalAlert({
                    variant: "warning",
                    title: err,
                    statusCode: 0,
                });
            });
    };

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            store: {
                required: {
                    value: data?.idStoreGlobal ? false : true,
                    message: errorsT("required"),
                },
            },
            pricingModel: {
                required: {
                    value: data?.idPricingModelGlobal ? false : true,
                    message: errorsT("required"),
                },
            },
            documentDate: {
                required: {
                    value: data?.documentDate?.day ? false : true,
                    message: errorsT("required")
                }
            },
        },
    });

    useEffect(() => dispatchGridFilterLot(onPharmacyChanged(baseFields.pharmacy.idGlobal)), [baseFields.pharmacy]);

    // Блокировка документа
    const requestUpdateLockingDocumentTimeout = useRef<NodeJS.Timeout>();
    const isUpdatingLockingDocument = useRef(false);

    useEffect(() => {
        // Если документ не определён — ничего не делаем
        if (!idLockingDocument) return;

        // Если уже идёт обновление — не ставим новый таймер
        if (isUpdatingLockingDocument.current) return;

        // Отменяем предыдущий таймер
        if (requestUpdateLockingDocumentTimeout.current) {
            clearTimeout(requestUpdateLockingDocumentTimeout.current);
        }

        clearTimeout(requestUpdateLockingDocumentTimeout.current as NodeJS.Timeout);
        requestUpdateLockingDocumentTimeout.current = setTimeout(() => {

            isUpdatingLockingDocument.current = true;

            lockingDocuments.update(idLockingDocument, (e) => {
                isUpdatingLockingDocument.current = false;
            },
                () => {
                    isUpdatingLockingDocument.current = false;
                })
        }, Number(process.env.REACT_APP_INTERVAL_REQUEST));
    }, [data.documentDate, data.idActRevaluationReasonGlobal, data.idPricingModelGlobal, data.idStoreGlobal, data.items]);

    useEffect(() => {
        if (data?.items) {
            setSum({
                ...sum,
                amountSupplierSum: data.items.reduce((sum, item) => sum + item.supplierCostInfo.sum, 0),
                amountSupplierVatSum: data.items.reduce((sum, item) => sum + item.supplierCostInfo.vatSum, 0),
                amountSupplierSumIncVat: data.items.reduce((sum, item) => sum + item.supplierCostInfo.sumIncVat, 0),
                amountRetailSum: data.items.reduce((sum, item) => sum + item.retailCostInfo.sum, 0),
                amountRetailVatSum: data.items.reduce((sum, item) => sum + item.retailCostInfo.vatSum, 0),
                amountRetailSumIncVat: data.items.reduce((sum, item) => sum + item.retailCostInfo.sumIncVat, 0),
            });
        }
    }, [data?.items, displayItems]);

    useEffect(() => {
        if (tabsContext?.currentTab) {
            currentIdTab.current = tabsContext.currentTab?.id;
        }
        if (props.variant === "create") {
            autocomplete().then((e) => {
                if(e.contractorMe) {
                storeDP.getById(e.contractorMe.store.idGlobal, (store) => {
                    setBaseFields({
                        ...baseFields,
                        pricingModel: store.pricingPricingModel ?? e.contractorMe?.pricingPricingModel,
                        store: e.contractorMe?.store ?? {} as IEntitySimpleDTO,
                        storeFromLot: {} as IEntitySimpleDTO,
                        pharmacy: store.contractor,
                    });
                    setData({
                        ...data,
                        idPricingModelGlobal: store.pricingPricingModel?.idGlobal ?? e.contractorMe?.pricingPricingModel?.idGlobal,
                        idStoreGlobal: e.contractorMe?.store.idGlobal,
                    });
                });
            }
            });
        }
        if ((props.variant === "edit" || props.variant === "copy") && props.document) {

            renderProgressView("Загрузка документа");

            if (props.variant === "edit")
                lockingDocuments.check(data.idGlobal as string, (e)=>{
                    if (e) setOnlyRead(true);
                    else
                        lockingDocuments.send({
                            idTable: IdTableVariant.ActRevaluation2,
                            idDocument: data.idGlobal as string,
                        }, (e)=> {
                            setIdLockingDocument(e)
                        });
                })

            let arr: IItemFilter[] = [];

            props.document.items?.forEach((x) => {
                lotDP.remain(x.lot.idGlobal, props.document?.idGlobal as string, (response) => {
                    arr.push({
                        idItem: x.idGlobal,
                        quantityMax: response,
                        quantityMin: 0,
                    });
                });
            });
            setItemsFilter(arr);
            const propsValidateItems = props.document.items.map((el) => ({
                err: false,
                message: "",
                idGlobal: el.idGlobal,
            })) as IValidationItem[];
            setItemsValidation(propsValidateItems);

            const timeoutClearValue: number = Math.max(
                1000, // минимум 1 секунда
                Math.min(
                    props.document.items?.length * 25,
                    25000 // максимум 25 секунд
                )
            )
            setTimeout(() => setModalWindow(<></>), timeoutClearValue);
        }
    }, []);

    useEffect(() => {
        const handleTabClose = (event) => {
            operativeReserve.deleteAll({ idTable: IdTableVariant.ActRevaluation2, idDocument: data.idGlobal as string });
            lockingDocuments.delete({
                idTable: IdTableVariant.ActRevaluation2,
                idDocument: data.idGlobal as string,
            });
            return (event.returnValue = "");
        };

        window.addEventListener("beforeunload", handleTabClose);

        return () => {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, []);

    useEffect(() => {
        if (data?.idStoreGlobal) {
            storeDP.getById(data.idStoreGlobal, (store) => {
                setBaseFields({
                    ...baseFields,
                    store: { idGlobal: data.idStoreGlobal as string, displayName: store.name },
                    pharmacy: store.contractor,
                });
                handleRequiredScanKizFromStore(store);
            });
            dispatchGridFilterLot({
                type: "addColumnFilter",
                payload: {
                    name: "idStoreGlobal",
                    operator: "Eq",
                    value: data.idStoreGlobal,
                },
            });
        } else {
            setBaseFields({ ...baseFields, store: {} as IEntitySimpleDTO });
            dispatchGridFilterLot({
                type: "deleteColumnFilter",
                payload: "idStoreGlobal",
            });
        }
    }, [data?.idStoreGlobal]);

    useEffect(() => {
        if (selectedItem) {
            scanner.isComPortScanner && setScanFocus(true);
            let item = data.items.find((x) => x.idGlobal === selectedItem.idGlobal);
            if (item) {
                setSelectedItemCreateDto(item);
                if (item?.idLotGlobal) {
                    lotDP.getById(data.items.find((x) => x.idGlobal === selectedItem.idGlobal)?.idLotGlobal as string, (e) => {
                        scalingRatioDP.overrideGetById(e.goods.idGlobal, e.scalingRatio.idGlobal, (scalingRatio) => {
                            setSelectedScalingRatio(scalingRatio);
                        });
                    });
                }
            } else {
                setSelectedItemCreateDto(undefined);
            }
        } else {
            scanner.isComPortScanner && setScanFocus(false);
            setSelectedScalingRatio(null);
        }
        setScanValue("");
    }, [selectedItem]);

    const isValidDocument = (items: IActRevaluationItemCreateDTO[], showMessage: () => void): boolean => {
        var flag = true;
        if (!items || items.length === 0) {
            flag = false;
            showMessage();
        }
        return flag;
    };

    const onOkAction = () => {
        lockingDocuments.delete({
            idTable: IdTableVariant.ActRevaluation2,
            idDocument: data.idGlobal as string,
        });

        props.ok(data);
    };

    const onOk = () => {
        if (isValid()) {
            if (
                isValidDocument(data.items, () => setShowMessageModalValidDocument({ message: errorsT("validDocument"), show: true })) === true &&
                controlKiz(data.items,
                    () => setShowMessageModal({ message: errorsT("kizCountNotMatch"), show: true, btSaveOrOk: "ok" }),
                    DocumentType.revaluation,
                    {
                        requiredMode: requiredScanKiz,
                        validationType: ""
                    }) === true
            ) {
                onOkAction();
                scanner.disconnect();
            }
        }
    };

    const onSave = () => {
        if (isValid()) {
            if (
                isValidDocument(data.items, () => setShowMessageModalValidDocument({ message: errorsT("validDocument"), show: true })) === true &&
                controlKiz(data.items,
                    () => setShowMessageModal({ message: errorsT("kizCountNotMatch"), show: true, btSaveOrOk: "save" }),
                    DocumentType.revaluation,
                    {
                        requiredMode: requiredScanKiz,
                        validationType: ""
                    }) === true
            ) {
                props.save(data);
                scanner.disconnect();
            }
        }
    };

    const onCancel = () => {
        operativeReserve.deleteAll(
            {
                idTable: IdTableVariant.ActRevaluation2,
                idDocument: data.idGlobal as string,
            },
            () => {
                props.cancel();
                scanner.disconnect();
            }
        );
        lockingDocuments.delete({
            idTable: IdTableVariant.ActRevaluation2,
            idDocument: data.idGlobal as string,
        });
    };

    const addItem = (value: IChangeDataGrid, percentageOfMarkupRetail: number, lot: ILotDTO, callbackFinally?: () => void) => {
        let dataRowItem = data.items.find((x) => x.idGlobal === value.idGlobal) as IActRevaluationItemCreateDTO;
        if (selectedScalingRatio?.idGlobal) {
            const itemData = {
                eventType: "QuantityСhanged",
                hasAdprice: true,
                hasRetailPrice: true,
                revaluationItem: {
                    idStoreGlobal: lot.store.idGlobal,
                    idSupplierGlobal: lot.idSupplierGlobal,
                    item: {
                        quantity: value.value,
                        adPrice: percentageOfMarkupRetail,
                        idGoodsGlobal: dataRowItem.idGoodsGlobal,
                        idScalingRatioGlobal: dataRowItem.idScalingRatioGlobal,
                        producerPrice: dataRowItem.producerPrice,
                        registerPrice: lot.registerPrice,
                        supplierCostInfo: dataRowItem.supplierCostInfo,
                        retailCostInfo: {
                            adprice: percentageOfMarkupRetail,
                            price: dataRowItem.retailCostInfo.price,
                            priceIncVat: dataRowItem.retailCostInfo.priceIncVat ?? 0,
                            sum: dataRowItem.retailCostInfo.sum,
                            sumIncVat: dataRowItem.retailCostInfo.sumIncVat,
                            vat: dataRowItem.retailCostInfo.vat ?? 0,
                            vatPrice: dataRowItem.retailCostInfo.vatPrice,
                            vatSum: dataRowItem.retailCostInfo.vatSum
                        } as ICostInfo,
                        numerator: selectedScalingRatio?.numerator ?? 1,
                        denominator: selectedScalingRatio?.denominator ?? 1
                    } as IPricingRevaluationItem
                } as IPricingRevaluationSingleItem
            } as IPricingRevaluationItemDTO

            calculateItem(itemData, value, callbackFinally);
        }
    };

    const calcRow = (value: IChangeDataGrid, isCalcAllItems?: boolean, hasAdprice?: boolean, hasRetailPrice?: boolean, event?: string) => {
        const dataRowItems = data.items.find((x) => x.idGlobal === value.idGlobal) as IActRevaluationItemCreateDTO;

        let retailPriceIncVat = value.propertyName === "retailPriceIncVat"
            ? Number(value.value)
            : dataRowItems.retailCostInfo.priceIncVat;

        const percentageOfMarkupRetail = value.propertyName === "retailAdprice"
            ? Number(value.value)
            : dataRowItems.retailCostInfo.adprice;

        //if (isCalcAllItems && percentageOfMarkupRetail > 0) {
        //    retailPriceIncVat = dataRowItems.supplierCostInfo.priceIncVat * (1 + percentageOfMarkupRetail / 100);
        //}

        lotDP.getById(dataRowItems.idLotGlobal, (lot: ILotDTO) => {
            // Общие данные
            const supplierCostInfo = lot.supplierCostInfo || {
                price: 0,
                priceIncVat: 0,
                vat: 0,
                sum: 0,
                vatSum: 0,
                sumIncVat: 0,
                vatPrice: 0
            };

            const commonData = {
                eventType: value.propertyName,
                hasAdprice: hasAdprice !== undefined ? hasAdprice : value.propertyName === "retailAdprice" ? true : false,
                hasRetailPrice: hasRetailPrice !== undefined ? hasRetailPrice : value.propertyName === "retailPriceIncVat" ? true : false,
                revaluationItem: {
                    idStoreGlobal: lot.store.idGlobal,
                    idSupplierGlobal: lot.idSupplierGlobal,
                    item: {
                        quantity: dataRowItems.quantity,
                        adPrice: percentageOfMarkupRetail,
                        idGoodsGlobal: lot.goods.idGlobal,
                        idScalingRatioGlobal: lot.scalingRatio.idGlobal,
                        producerPrice: lot.producerPrice,
                        registerPrice: lot.registerPrice,
                        supplierCostInfo: supplierCostInfo,
                        retailCostInfo: {
                            adprice: percentageOfMarkupRetail,
                            price: dataRowItems.retailCostInfo.price,
                            priceIncVat: retailPriceIncVat,
                            sum: dataRowItems.retailCostInfo.sum,
                            sumIncVat: dataRowItems.retailCostInfo.sumIncVat,
                            vat: dataRowItems.retailCostInfo.vat ?? 0,
                            vatPrice: dataRowItems.retailCostInfo.vatPrice,
                            vatSum: dataRowItems.retailCostInfo.vatSum
                        } as ICostInfo,
                        numerator: selectedScalingRatio?.numerator ?? 1,
                        denominator: selectedScalingRatio?.denominator ?? 1
                    } as IPricingRevaluationItem
                } as IPricingRevaluationSingleItem
            } as IPricingRevaluationItemDTO

            // Обработка события
            switch (value.propertyName) {
                case "retailPriceIncVat":
                    calculateItem(
                        {
                            ...commonData,
                            eventType: event ?? "RetailPriceWithVatChanged"
                        },
                        value,
                        () => setModalWindow(<></>),
                        isCalcAllItems ? false : true
                    );
                    break;

                case "retailAdprice":
                    calculateItem(
                        {
                            ...commonData,
                            revaluationItem: {
                                ...commonData.revaluationItem,
                                item: {
                                    ...commonData.revaluationItem.item,
                                    adPrice: Number(value.value),
                                    retailCostInfo: {
                                        ...commonData.revaluationItem.item.retailCostInfo,
                                        adprice: Number(value.value)
                                    }
                                }
                            },
                            eventType: event ?? "PercentageOfMarkupRetailChanged",
                        },
                        value,
                        () => setModalWindow(<></>),
                        isCalcAllItems ? false : true
                    );
                    break;

                case "retailPrice":
                    calculateItem(
                        {
                            ...commonData,
                            revaluationItem: {
                                ...commonData.revaluationItem,
                                item: {
                                    ...commonData.revaluationItem.item,
                                    retailCostInfo: {
                                        ...commonData.revaluationItem.item.retailCostInfo,
                                        price: Number(value.value)
                                    }
                                }
                            },
                            eventType: event ?? "RetailPriceChanged"
                        },
                        value,
                        () => setModalWindow(<></>),
                        isCalcAllItems ? false : true
                    );
                    break;

                case "quantity":
                    if (isCalcAllItems) {
                        // Пересчёт по модели осуществляется через событие по параметру 'КВ'
                        calculateItem(
                            {
                                ...commonData,
                                revaluationItem: {
                                    ...commonData.revaluationItem,
                                    item: {
                                        ...commonData.revaluationItem.item,
                                        quantity: Number(value.value)
                                    }
                                },
                                eventType: event ?? "QuantityСhanged",
                            },
                            value,
                            () => setModalWindow(<></>),
                            false
                        );
                    } else {
                        operativeReserve.send(
                            {
                                idLot: dataRowItems.idLotGlobal,
                                idDocument: data.idGlobal as string,
                                idTable: IdTableVariant.ActRevaluation2,
                                idDocumentItem: value.idGlobal,
                                quantity: Number(value.value),
                            },
                            () => addItem(value, percentageOfMarkupRetail, lot, () => setModalWindow(<></>)),
                        );
                    }
                    break;
            }
        });
    };

    const firstRender = useRef(true);
    useEffect(() => {
        if (!data.idPricingModelGlobal) return;

        pricingModelDP.getById(data.idPricingModelGlobal, (newModel: IPricingModelDTO) => {

            // Сравнение изменения состояния по IdGlobal
            if (!pricingModelDto || pricingModelDto.idGlobal !== newModel.idGlobal) {
                setPricingModelDto(newModel);

                if (firstRender.current) {
                    firstRender.current = false;
                } else {
                    renderProgressView("Расчёт розничных цен");
                    calcAllItems(newModel);
                }
            }
        });
    }, [data.idPricingModelGlobal]);

    const calcAllItems = (pricing?: IPricingModelDTO) => {

        pricing = pricing ?? pricingModelDto;

        if (!pricing || !data.items || !displayItems || displayItems.length === 0) {
            setModalWindow(<></>);
            return;
        }

        // Функция для формирования DTO для одного item
        // Принимает параметры, аналогичные calcRow
        const buildCalcItemDto = (
            item: IActRevaluationItemCreateDTO,
            propertyName: string, // например, "quantity", "retailPriceIncVat", "retailPrice"
            eventValue: number | undefined, // значение, например, x.quantity, x.retailPriceIncVatOld, x.retailCostInfo.priceIncVat
            hasAdprice: boolean,
            hasRetailPrice: boolean, // например, true для recountFixRetailPrice
            eventString: string | undefined // например, "retailPriceChanged"
        ): Promise<IPricingRevaluationItemDTO> => {
            return new Promise((resolve, reject) => {
                lotDP.getById(item.idLotGlobal, (lot: ILotDTO) => {
                    const supplierCostInfo = lot.supplierCostInfo || {
                        price: 0,
                        priceIncVat: 0,
                        vat: 0,
                        sum: 0,
                        vatSum: 0,
                        sumIncVat: 0,
                        vatPrice: 0
                    };

                    // Определяем eventType на основе propertyName или eventString
                    let eventType: string;
                    if (eventString) {
                        eventType = eventString;
                    } else {
                        switch (propertyName) {
                            case "retailPriceIncVat":
                                eventType = "RetailPriceWithVatChanged";
                                break;
                            case "retailAdprice":
                                eventType = "PercentageOfMarkupRetailChanged";
                                break;
                            case "retailPrice":
                                eventType = "RetailPriceChanged";
                                break;
                            case "quantity":
                                eventType = "QuantityСhanged";
                                break;
                            default:
                                eventType = "QuantityСhanged"; // по умолчанию
                        }
                    }

                    // Подготовка retailCostInfo в зависимости от propertyName и eventValue
                    let retailCostInfoForEvent = { ...item.retailCostInfo };
                    switch (propertyName) {
                        case "retailPriceIncVat":
                            if (eventValue !== undefined) {
                                retailCostInfoForEvent = {
                                    ...retailCostInfoForEvent,
                                    priceIncVat: eventValue
                                };
                            }
                            break;
                        case "retailAdprice":
                            if (eventValue !== undefined) {
                                retailCostInfoForEvent = {
                                    ...retailCostInfoForEvent,
                                    adprice: eventValue
                                };
                            }
                            break;
                        case "retailPrice":
                            if (eventValue !== undefined) {
                                retailCostInfoForEvent = {
                                    ...retailCostInfoForEvent,
                                    price: eventValue
                                };
                            }
                            break;
                        // Для quantity retailCostInfo остается как есть, но quantity обновляется
                        case "quantity":
                        default:
                            break;
                    }

                    const dto: IPricingRevaluationItemDTO = {
                        eventType: eventType,
                        hasAdprice: hasAdprice, // Устанавливаем из параметра
                        hasRetailPrice: hasRetailPrice, // Устанавливаем из параметра
                        revaluationItem: {
                            idGlobal: item.idGlobal, // Важно: передаем idGlobal item'а, чтобы сопоставить результат
                            idStoreGlobal: lot.store.idGlobal,
                            idSupplierGlobal: lot.idSupplierGlobal,
                            item: {
                                idGlobal: item.idGlobal,
                                quantity: propertyName === "quantity" && eventValue !== undefined ? eventValue : item.quantity, // Обновляем quantity, если propertyName === "quantity"
                                adPrice: retailCostInfoForEvent.adprice,
                                idGoodsGlobal: lot.goods.idGlobal,
                                idScalingRatioGlobal: lot.scalingRatio.idGlobal,
                                producerPrice: lot.producerPrice,
                                registerPrice: lot.registerPrice,
                                supplierCostInfo: supplierCostInfo,
                                retailCostInfo: retailCostInfoForEvent,
                                numerator: selectedScalingRatio?.numerator ?? 1,
                                denominator: selectedScalingRatio?.denominator ?? 1
                            } as IPricingRevaluationItem
                        } as IPricingRevaluationSingleItem
                    } as IPricingRevaluationItemDTO;

                    resolve(dto);
                }, (error) => {
                    console.error('Ошибка получения данных партии по строке документа:', item.idGlobal, error);
                    reject(error);
                });
            });
        };

        // Функция, которая формирует DTO для списка items и вызывает batch
        const executeBatchCalculationWithParams = async (
            itemsToRecalc: IActRevaluationItemCreateDTO[],
            propertyName: string,
            getEventValue: (item: IActRevaluationItemCreateDTO) => number | undefined,
            hasAdprice: boolean,
            hasRetailPrice: boolean,
            eventString?: string
        ) => {
            try {
                renderProgressView("Подготовка запроса");

                const calcItemsPromises = itemsToRecalc.map(item => {
                    const eventValue = getEventValue(item);
                    return buildCalcItemDto(item, propertyName, eventValue, hasAdprice, hasRetailPrice, eventString);
                });
                const calcItems = await Promise.all(calcItemsPromises);

                if (calcItems.length === 0) {
                    setModalWindow(<></>);
                    return;
                }

                calculateBatch(calcItems, () => {
                    setModalWindow(<></>);
                });
            } catch (error) {
                console.error('Ошибка при подготовке данных для пересчета: ', error);
                renderGlobalAlert({
                    variant: "warning",
                    title: "Ошибка при подготовке данных для пересчета",
                    statusCode: 0,
                });
                setModalWindow(<></>);
            }
        };

        setModalWindow(<ActRevaluationRecalcModal
            header={'[' + `${pricing?.name as string}` + '] Пересчитать розничную цену'}
            label={''}
            options={[
                { value: "recountModelValuesOption", label: baseT("recountModelValuesOption") },
                { value: "recountFixRetailPrice", label: baseT("recountFixRetailPrice") },
                { value: "recountVatUp", label: baseT("recountVatUp") },
                { value: "recountWithMarkupPercent", label: baseT("recountWithMarkupPercent") },
                { value: "recountWithMarkupOrMarkdown", label: baseT("recountWithMarkupOrMarkdown") },
                { value: "recountToSupplierPriceIncVat", label: baseT("recountToSupplierPriceIncVat") }
            ]}
            selectedValue={undefined}
            onSelect={async (value: any, markupPercent: number, markupOrMarkdownState: IMarkupOrMarkdownState) => {
                switch (value) {
                    case "recountModelValuesOption":
                        await executeBatchCalculationWithParams(
                            data.items,
                            "quantity",
                            (item) => item.quantity,
                            false, // hasAdprice
                            false, // hasRetailPrice
                            undefined // eventString
                        );
                        break;

                    case "recountFixRetailPrice":
                        await executeBatchCalculationWithParams(
                            data.items,
                            "retailPriceIncVat",
                            (item) => item.retailPriceIncVatOld as number,
                            false, // hasAdprice
                            true, // hasRetailPrice
                            "RetailPriceWithVatChanged"
                        );
                        break;

                    case "recountVatUp":
                        await executeBatchCalculationWithParams(
                            data.items,
                            "retailPrice",
                            (item) => item.retailCostInfo.priceIncVat,
                            false, // hasAdprice
                            true, // hasRetailPrice
                            "RetailPriceChanged" // eventString

                        );
                        break;

                    case "recountWithMarkupPercent": //Использовать заданный процент наценки
                        await executeBatchCalculationWithParams(
                            data.items,
                            "retailAdprice",
                            () => markupPercent as number,
                            true,
                            false,
                            "PercentageOfMarkupRetailChanged"
                        )
                        break;

                    case "recountWithMarkupOrMarkdown": //Произвести Наценку/Уценку
                        // изменяя процент наценки
                        if (markupOrMarkdownState.priceAdjustmentMethod === PriceAdjustmentMethod.PERCENTAGE) {
                                await executeBatchCalculationWithParams(
                                    data.items,
                                    "retailAdprice",
                                    (item) => calcPercentageValue(
                                        item.retailCostInfo.adprice,
                                        markupOrMarkdownState.priceAdjustmentType,
                                        markupOrMarkdownState?.absolute,
                                        markupOrMarkdownState?.percent,
                                        markupOrMarkdownState?.adjustmentFactorType
                                    ),
                                    true,
                                    false,
                                    "PercentageOfMarkupRetailChanged"
                                )
                        }
                        // изменяя цену
                        if (markupOrMarkdownState.priceAdjustmentMethod === PriceAdjustmentMethod.ABSOLUTE) {
                                await executeBatchCalculationWithParams(
                                    data.items,
                                    "retailPriceIncVat",
                                    (item) => calcAbsoluteValue(
                                        item.retailCostInfo.priceIncVat,
                                        markupOrMarkdownState.priceAdjustmentType,
                                        markupOrMarkdownState?.absolute,
                                        markupOrMarkdownState?.percent,
                                        markupOrMarkdownState?.adjustmentFactorType
                                    ),
                                    true,
                                    false,
                                    "RetailPriceWithVatChanged"
                                )
                        }
                        break;

                    case "recountToSupplierPriceIncVat": //пересчет всех товаров до цены поставщика с НДС
                        await executeBatchCalculationWithParams(
                            data.items,
                            "retailPriceIncVat",
                            (item) => item.supplierCostInfo.priceIncVat as number,
                            false,
                            true,
                            "RetailPriceWithVatChanged"
                        )                        
                        break;

                    default:
                        await executeBatchCalculationWithParams(
                            data.items,
                            "quantity",
                            (item) => item.quantity,
                            false, // hasAdprice
                            false, // hasRetailPrice
                            undefined // eventString
                        );
                        break;
                }
            }}
            cancel={() => {
            }}
            close={() => setModalWindow(<></>)}
        />)
    }

    const calcPercentageValue = (
        oldValue: number,
        type: PriceAdjustmentType,
        absolute: number,
        percent: number,
        adjustmentFactorType: AdjustmentFactorType
    
    ) => {
        if (type === PriceAdjustmentType.MARKUP) {
            if (adjustmentFactorType === AdjustmentFactorType.PERCENT) {
                const newValue = oldValue + percent
                return newValue
            } else {
                const newValue = oldValue * absolute
                return newValue
            }
        } else {
            if (adjustmentFactorType === AdjustmentFactorType.PERCENT) {
                const newValue = oldValue - percent
                return newValue
            } else {
                const newValue = oldValue / absolute
                return newValue
            }
        }
    }

    const calcAbsoluteValue= (
        oldValue: number,
        type: PriceAdjustmentType,
        absolute: number,
        percent: number,
        adjustmentFactorType: AdjustmentFactorType
    
    ) => {
        if (type === PriceAdjustmentType.MARKUP) {
            if (adjustmentFactorType === AdjustmentFactorType.PERCENT) {
                const newValue = oldValue * (1 + percent / 100)
                return newValue
            } else {
                const newValue = oldValue * absolute
                return newValue
            }
        } else {
            if (adjustmentFactorType === AdjustmentFactorType.PERCENT) {
                const newValue = oldValue * (1 - percent / 100)
                return newValue
            } else {
                const newValue = oldValue / absolute
                return newValue
            }
        }
    }
    
    const isDisabledEditPanel = () => {
        const item = data.items.find((item) => item.idGlobal == selectedItem?.idGlobal)
        return onlyRead || !(item?.isKiz || item?.isOsu)
    }

    const validateKiz =(searchQuery: string ):boolean => {
        if (KizBoxEntity.isKizBox(searchQuery) || new KizParsed(searchQuery).isKiz) {
            {
                const kizs = data.items.flatMap(x => x.kizs) as IKizDTO[]
                const kizBoxes = data.items.flatMap(x => x.kizBoxes) as IKizBoxDTO[]
                const barcode = buffer.Buffer.from(searchQuery, "ascii").toString("base64")
                if (!validateDuplicateKizs(data.items, barcode, DocumentType.revaluation, kizs, kizBoxes))
                {
                    renderGlobalAlert({
                        variant: "exception",
                        title: `${barcode} уже был добавлен ранее в текущем документе`,
                        detail:`${barcode} уже был добавлен ранее в текущем документе`,
                        statusCode: 500,
                        isSound: true
                    });
                    return false;
                }
                return true;
            }
        }  
        return true;
    }

    const renderProgressView = (actionMessage: string) => {
        setModalWindow(
            <ProgressActionSpinner
                loaderText={`${actionMessage}`}
            />
        );
    };

    const otherActions: IButton[] = [
        {
            title: baseT("getRemains"),//"Получить остатки"
            disabled: data.idStoreGlobal === null ||
                props.document?.documentState === DocumentStateType.proc ||
                displayItems.length > 0 ||
                lockFromPermission,
            onClick: async () => fillWithRemainedLots()
        },
    ];

    const fillWithRemainedLots = () => {

        setModalWindow(
            <ProgressActionSpinner
                loaderText={"Подготовка документа переоценки"}
            />);

        if (data?.idStoreGlobal != undefined && displayItems.length === 0) {

            const customPricingModelId = data.idPricingModelGlobal && data.idPricingModelGlobal.length > 0 ?
                    data.idPricingModelGlobal :
                    null

            if (props.variant == 'create') {

                // Значение лимита строк документа 
                // Не влияет при ActRevaluationRemnantsType.AllRemnants
                actRevaluationDP.createFromStore(
                    data.idStoreGlobal,
                    2500,
                    ActRevaluationRemnantsType.AllRemnants,
                    false,
                    data.newBarcode,
                    customPricingModelId,
                    (response: IActRevaluationFromSingleStoreResponse) => {

                        const creationValid = response.createdIds && response.createdIds.length === 1;
                        if (response.infoMessages && response.infoMessages.length > 0) {
                            renderGlobalAlert({
                                statusCode: 0,
                                variant: creationValid ? "info" : "warning",
                                title: "Предупреждения при создании документа 'Акт переоценки'",
                                detail: response.infoMessages
                            })

                            !creationValid && console.warn(response.infoMessages);
                        }

                        if (creationValid) {
                            props.redirect?.(response.createdIds[0], 'edit');
                        }

                        setModalWindow(<></>)
                    },
                    (e: any) => {

                        setModalWindow(<></>)
                    })
            } else {

                // Заполнение текущего документа остатками
                if (data.idGlobal !== undefined) {
                    const putRequest = {
                        calculateWithPricingModel: false,
                        eventName: "QuantiyChanged",
                        valueName: "QuantityRem",
                        hasRetailPrice: true,
                        revaluationTaxType: Number(TaxTypesOptions[0].value),
                        generateNewBarcodes: data.newBarcode,
                        idPricingModel: customPricingModelId
                    } as IActRevaluationFillWithRemnantsOnStoreDto
                    actRevaluationDP.fillWithRemnantsOnStore(data.idGlobal, 
                        putRequest, 
                        (response: IActRevaluationFillWithRemnantsOnStoreResponse) => {
                            const fillValid = response.documentId !== uuidNull;

                            if (response.infoMessages && response.infoMessages.length > 0) {
                                renderGlobalAlert({
                                    statusCode: 0,
                                    variant: fillValid ? "info" : "warning",
                                    title: "Предупреждения при формировании строк документа 'Акт переоценки'",
                                    detail: response.infoMessages
                                })

                                !fillValid && console.warn(response.infoMessages);
                            }

                            if (fillValid) {
                                props.refresh?.()
                            }

                            setModalWindow(<></>)
                        },
                    (e: any) => {
                        setModalWindow(<></>)
                    })
                }
            }
        }
    }

    const renderDeleteModalWindow = (entityTitle: string, customText: string | null, customElement: JSX.Element | string | null = null, deleteEntityFunc: any) => {
        setModalWindow(
            <DeleteModalWindow
                name={`${entityTitle} `}
                customText={customText}
                element={customElement as JSX.Element ?? <><br /><span><b>{entityTitle}</b>&nbsp;?</span></>}
                hideDefaultQuestionMark={true}
                cancel={{
                    onClick: () => {
                        setModalWindow(<></>); // TODO: viewState?
                    },
                }}
                delete={{
                    onClick: () => {
                        deleteEntityFunc();
                        setModalWindow(<></>);
                    },
                    title: t("general.delete") //"Удалить"
                }}
            />
        );
    };

    function transformArray(lots: ILotDTO[]) {
        const edit: IActRevaluationItemCreateDTO[] = [];
        const view: IDisplayItem[] = []
        lots.forEach(x => {
            const idGlobal: string = uuidv4();
            const quantity = 1

            const editEntity = {
                idGlobal: idGlobal,
                isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                goodsCode: x.goodsCode,
                producer: x.producer?.displayName,
                idLotGlobal: x.idGlobal,
                retailCostInfo: x.retailCostInfo,
                supplierCostInfo: x.supplierCostInfo,
                retailAdprice: x.productMargin ?? 0,
                retailVat: x.retailCostInfo?.vat ?? 0,
                quantity: quantity,
                retailPrice: x.retailCostInfo?.price,
                retailPriceVat: x.retailCostInfo?.priceIncVat ?? 0,
                retailSum: x.retailCostInfo?.sum ?? 0,
                retailVatSum: x.retailCostInfo?.vatSum ?? 0,
                retailSumVat: x.retailCostInfo?.sumIncVat ?? 0,
                producerPrice: x.producerPrice,
                retailAdpriceOld: x.retailCostInfo.adprice,
                retailPriceIncVatOld: x.retailCostInfo.priceIncVat,
                supplierAdprice: 0,
                isKiz: x.isKiz,
                kizs: [],
                kizBoxes: [],
                idGoodsGlobal: x.goods.idGlobal,
                idScalingRatioGlobal: x.scalingRatio.idGlobal,
                comment: "",
                dateCreated: DateTime.now(),
                isOsu: x?.kizOsuDto?.barcode !== undefined,
                kizOsuDto: x?.kizOsuDto

            };

            const viewEntity = {
                idGlobal: idGlobal,
                goodsName: x.goods.displayName,
                storeName: x.store.displayName,
                goodsCode: x.goodsCode,
                retailAdpriceOld: x.retailCostInfo.adprice,
                retailPriceIncVatOld: x.retailCostInfo.priceIncVat,
                retailAdprice: x.retailCostInfo.adprice,
                producer: x.producer?.displayName,
                idLotGlobal: x.idGlobal,
                retailPriceIncVat: x.retailCostInfo?.priceIncVat ?? 0,
                retailSumIncVat: x.retailCostInfo?.sumIncVat ?? 0,
                quantity: quantity,
                isKiz: x.isKiz || false,
                isGnvls: false,
                countKizScan: x.isKiz === false ? undefined : 0,
                dateCreated: DateTime.now(),
                isOsu: x.kizOsuDto?.barcode !== undefined
            };

            edit.push(editEntity);
            view.push(viewEntity);
        });
        return {
            edit,
            view
        };
    }

    const onSelectLots = (lots: ILotDTO[]) => {
        const existingIds = new Set(data.items?.map(item => item.idLotGlobal) ?? []);
        const uniqueRows = lots.filter(lot => !existingIds.has(lot.idGlobal))

        if (uniqueRows.length === 0) {
            return;
        }

        const { edit, view } = transformArray([...uniqueRows]);
        const addItems = async (items: IActRevaluationItemCreateDTO[]) => {
            try {
                const promises = items.map((item) =>
                    new Promise<IActRevaluationItemCreateDTO>((resolve) => {
                        operativeReserve.send(
                            {
                                idLot: item.idLotGlobal as string,
                                idTable: IdTableVariant.ActRevaluation2,
                                idDocument: props.idGlobal ?? '',
                                idDocumentItem: item.idGlobal,
                                quantity: item.quantity,
                            },
                            () => resolve(item)
                        );
                    })
                );
                await Promise.all(promises);

                setData(prev => ({ 
                    ...prev, 
                    items: [...(prev?.items ?? []), ...items] 
                }));
                
                setDisplayItems(prev => [...(prev ?? []), ...view]);

            } catch (error) {
                console.error("Ошибка", error);
            }
        }
        addItems(edit);
    }

    const handleRequiredScanKizFromStore = (storeFrom: IStoreDTO | null) => {
        const isRequired = storeFrom?.kizScanning === true;
        setRequiredScanKiz(isRequired);
    };

    const handleLotSelect = (lotData: any, searchQuery?: string) => {
        if (Array.isArray(lotData)) {
            Promise.all(
                lotData.map(item =>
                    new Promise<ILotDTO>(resolve => lotDP.getById(item.idGlobal, resolve))
                )
            ).then(onSelectLots);
            return;
        }

        lotDP.getById(lotData.idGlobal, (lotDto: ILotDTO) => {
            if (!checkStorePharmacy(lotDto, baseFields.store, baseFields.pharmacy)) return;
            if (!validateKiz(searchQuery ?? '')) return;

            if (searchOption.value === SearchOption.goodsName ||
                searchOption.value === SearchOption.goodsCodeBylot ||
                searchOption.value === SearchOption.gtinSgtin) 
            {
                lotDP.remain(lotData.idGlobal, data.idGlobal as string, (remain) => {
                    setCreatorItem({ 
                        lot: { ...lotDto, quantityRem: remain }, 
                        show: true, 
                        editItem: null 
                    });
                });
            } else if (
                searchOption.value === SearchOption.kizOrKizBox ||
                searchOption.value === SearchOption.internalBarcode
            ) {
                setCreatorItem({ lot: lotDto, show: true, editItem: null });
            }
        });
    };

    return (
        <BaseDocumentCreator
            valid
            save={{
                onClick: onSave,
                disabled: onlyRead || !!itemsValidation.find((x) => x.err) || props.isSubmitting,
                sendRequestGlobal: props.isSubmitting
            }}
            cancel={{ onClick: onCancel }}
            ok={{
                onClick: onOk,
                disabled: onlyRead || !!itemsValidation.find(x => x.err) || props.isSubmitting,
                sendRequestGlobal: props.isSubmitting
            }}
            print={{
                onClick: () => {
                    return IdTableVariant.ActRevaluation2;
                },
                onSubItemClick: () => {
                    let arr = new Array<IKeyValuePair>();
                    if (props.document !== undefined && props.document?.mnemocode !== undefined && props.idGlobal !== undefined) arr.push({ key: props.idGlobal, value: props.document.mnemocode });
                    return arr;
                },
            }}
            otherMenuActions={otherActions}
        >
            <div className={styles.glwrapper}>
                <div className={styles.wrapper}>
                    <div>
                        <GridWrapper cols={2} baseline>
                            <TextInput
                                labelClassName={styles.numberLabel}
                                disabled={true}
                                label={baseT("number")}
                                inputId={`number-${uuidv4()}`}
                                inline={true}
                                value={props.variant === "edit" && props.document ? props.document.mnemocode : undefined}
                                //onChange={(value) => {}}
                            />
                            <DateInput
                                required
                                disabled={onlyRead}
                                labelVariant="required"
                                inputId={`date-${uuidv4()}`}
                                label={baseT("date")}
                                value={data.documentDate}
                                onBlur={(value) => setData({ ...data, documentDate: value as DateTime })}
                                inline
                                error={errors.documentDate}
                            />
                        </GridWrapper>
                        <GridWrapper cols={2}>
                            <StoreSelectorPanel
                                we
                                required
                                idTable={idTable}
                                compactMode
                                change={onCanChangeData(data.items.length)}
                                storeFromLot={baseFields.storeFromLot}
                                contractor={{
                                    label: baseT("pharmacy"),
                                    onSelect: (value) => value && setBaseFields({ ...baseFields, pharmacy: value }),
                                    onClear: () => setBaseFields({ ...baseFields, pharmacy: {} as IEntitySimpleDTO }),
                                    disabled: onlyRead,
                                    treeViewCheckDirectoryType:'pharmacy'
                                }}
                                store={{
                                    label: baseT("store"),
                                    value: baseFields.store,
                                    onSelect: (value) => value && setData({ ...data, idStoreGlobal: value.idGlobal }),
                                    onClear: () => {
                                        setData({ ...data, idStoreGlobal: undefined });
                                    },
                                    error: errors.store,
                                    onFocus: () => setErrors({ ...errors, store: undefined }),
                                    disabled: onlyRead,
                                    className: styles.defaultMargin
                                }}
                                notAutoComplete={props.variant === "edit" || props.variant === "copy"}
                                documentStore={props.document?.store}
                            />
                        </GridWrapper>
                        <GridWrapper cols={5} baseline>
                            <GridSelectorInput
                                required
                                disabled={onlyRead ? true : false}
                                variant="required"
                                className={styles.field_PriceModel}
                                selectorModalJsx={PricingModelSelectorModal}
                                label={baseT("pricingModel")}
                                id={`pricingModel-${uuidv4()}`}
                                selectedEntity={baseFields.pricingModel}
                                onSelect={(value) => {
                                    setData({ ...data, idPricingModelGlobal: value.idGlobal });
                                    setBaseFields({ ...baseFields, pricingModel: value });
                                }}
                                inline={true}
                                error={errors.pricingModel}
                                onFocus={() => setErrors({ ...errors, pricingModel: undefined })}
                                onClear={() => setBaseFields(prev => ({ ...prev, pricingModel: { displayName: '', idGlobal: ''}}))}
                            />
                            <Button
                                disabled={onlyRead ? true : false}
                                className={styles.field_Recalculate}
                                variant="primary"
                                onClick={() => {
                                    calcAllItems();
                                }}
                            >
                                {" "}
                                Пересчитать {" "}
                            </Button>
                        </GridWrapper>

                        <GridWrapper cols={3}>
                            <GridSelectorInput
                                selectorModalJsx={PricingModelSelectorModal}
                                selectedEntity={{} as IEntitySimpleDTO}
                                label={baseT("actRevaluationReason")}
                                id={`reason-${uuidv4()}`}
                                inline={true}
                                //onSelect={(entity) => {}}
                                disabled
                            />
                            <DictionaryInput 
                                inline 
                                disabled={onlyRead}
                                placeholder="-- Не выбрано --" 
                                value={displayNameBaseDoc} 
                                label={baseT("baseDocument")} 
                                onMoreClick={() => {
                                    !baseFields?.store?.idGlobal ? setShowMessageModalValidBaseDocument(true) : setSelectBaseDocument(true);
                                }} 
                            />
                            <CheckBox
                                onChanged={(value) => setData({ ...data, newBarcode: value })}
                                defaultChecked={data.newBarcode}
                                id={uuidv4()}
                                className="createMovementsStyles.field_GenerateNewBarcode"
                                label={`Формировать\u00a0новый\u00a0штрих\u00a0код`}
                                disabled={onlyRead}
                            />
                        </GridWrapper>
                        <Accordion opened={false} id={`ActRevaluationComment-${uuidv4()}`} caption="Комментарий">
                            <TextAreaInput 
                                disabled={onlyRead}
                                placeholder="Напишите комментарий" 
                                value={data.comment} 
                                onChange={(value) => setData({ ...data, comment: value })} 
                            />
                        </Accordion>

                        <FlexRow className={styles.field_flexblock}>
                            <PositionEditPanel
                                kiz={{
                                    onClick: () => {                                        
                                        setShowKizScan(true);                                        
                                    },
                                    disabled: isDisabledEditPanel()
                                }}
                                edit={{
                                    onClick: () => {
                                        const editItem = data.items.find((x) => x.idGlobal === selectedItem?.idGlobal) as IActRevaluationItemCreateDTO;
                                        if (selectedItem) {
                                            lotDP.getById(editItem.idLotGlobal, (lotDto: ILotDTO) => {
                                                setCreatorItem({ lot: lotDto, show: true, editItem: editItem });
                                            });
                                        }
                                    },
                                    disabled: !selectedItem || onlyRead,
                                }}
                                delete={{
                                    onClick: () => {
                                        if (selectedItem) {
                                            let item = data.items.find((x) => x.idGlobal === selectedItem.idGlobal);
                                            if (item) {
                                                operativeReserve.delete(
                                                    {
                                                        idLot: item.idLotGlobal,
                                                        idTable: IdTableVariant.ActRevaluation2,
                                                        idDocument: data.idGlobal as string,
                                                        idDocumentItem: item.idGlobal as string,
                                                    },
                                                    () => {
                                                        setData({ ...data, items: data.items.filter((x) => x.idGlobal !== selectedItem.idGlobal) });
                                                        setDisplayItems([...displayItems.filter((x) => x.idGlobal !== selectedItem.idGlobal)]);

                                                        const itemsValid = itemsValidation.filter((item) => item.idGlobal !== selectedItem.idGlobal);
                                                        const itemsFilterValid = itemsFilter.filter((item) => item.idItem !== selectedItem.idGlobal);
                                                        setItemsValidation(itemsValid);
                                                        setItemsFilter(itemsFilterValid);
                                                    }
                                                );
                                            }
                                        }
                                    },
                                    disabled: !selectedItem || onlyRead,
                                }}
                                clear={{
                                    onClick: () => {
                                        if (data.idGlobal && data.items.length > 0 && displayItems.length > 0) {
                                            const clear = () => {
                                                operativeReserve.deleteAll(
                                                    {
                                                        idTable: IdTableVariant.ActRevaluation2,
                                                        idDocument: data.idGlobal as string
                                                    },
                                                    () => {
                                                        actRevaluationDP.deleteReserves(data.idGlobal as string, () => {
                                                            setData({ ...data, items: [] });
                                                            setDisplayItems([]);
                                                        })
                                                    })
                                            }

                                            const customElement = <><br/><span>{baseT("messages.clearAlert")}<br/><b>{t("general.confirm")}</b></span></>;
                                            renderDeleteModalWindow(baseT("messages.clearProcessName"), "", customElement, clear);
                                        }
                                    },
                                    disabled: onlyRead || !data?.items || data?.items?.length === 0
                                }}
                            />
                            <GridSelectorInput
                                disabled={onlyRead || !baseFields.pricingModel.idGlobal}
                                barcodeScan={tabsContext.currentTab && tabsContext.currentTab?.id === currentIdTab.current}
                                selectorModalJsx={LotsSelectorModal}
                                className={styles.field_SelectionGoods}
                                id={"inputAccompanyingSelectionGoods"}
                                idTable={idTable}
                                inline
                                label={baseT("selectionOfGoods")}
                                gridFilter={gridFilterLot}
                                dispatchGridFilter={dispatchGridFilterLot}
                                onSelect={handleLotSelect}
                                onClear={() => {}}
                                searchOption={searchOption.value}
                                setScanData={setScanData}
                                onChange={setScanData}
                                activateGroupProcessing
                                idStoreGlobal={data.idStoreGlobal}
                            />
                            <Select
                                disabled={onlyRead}
                                barcodeScan={tabsContext.currentTab && tabsContext.currentTab?.id === currentIdTab.current}
                                onSelect={(option) => {
                                    setSearchOption(option);
                                }}
                                value={searchOption}
                                defaultOption={defaultSearchOption}
                                className={styles.field_SelectBlock}
                                options={[
                                    { displayName: t("documents.movement.goodsName"), value: SearchOption.goodsName },
                                    { displayName: t("documents.movement.kizOrKizBox"), value: SearchOption.kizOrKizBox },
                                    { displayName: t("documents.movement.goodsCodeBylot"), value: SearchOption.goodsCodeBylot },
                                    { displayName: t("documents.movement.internalBarcode"), value: SearchOption.internalBarcode },
                                    { displayName: t("documents.movement.gtinSgtin"), value: SearchOption.gtinSgtin },
                                ]}
                            />
                            <TextInput
                                className={styles.field_Empty}
                                disabled
                                label=""
                                inputId={"inputAccompanyingEmpty"}
                                inline /* value={accompanyingInvoiceInfo?.empty} onChange={(value) => setAccompanyingInvoiceInfo({ ...accompanyingInvoiceInfo, empty: value })}*/
                            />

                            <div className={styles.SettingsButton}>
                                <SettingsButtonModal 
                                    disabled={onlyRead}
                                />
                            </div>
                        </FlexRow>
                        <ChangeableGrid
                            virtualizedData
                            documentStateProc={onlyRead}
                            // Временно закомменитировано - некорректно работает
                            // если количество в партии = 10 и меняем цену выше 10, валидация не проходит - нельзя сохранить документ

                            // itemsFilter={itemsFilter}
                            // itemsValidation={itemsValidation}
                            // setItemsValidation={(value) => {
                            //     const newItemsValidation = itemsValidation.map((item) => (item.idGlobal === value[0].idGlobal ? { ...item, ...value } : item));
                            //     setItemsValidation(newItemsValidation);
                            // }}
                            gridId={uuidv4()}
                            
                            data={displayItems}
                            documentType={DocumentType.revaluation}
                            hiddenPagination={undefined}
                            filter={gridFilter}
                            totalCount={displayItems.length}
                            plugin={RevaluationItemGridPluginSettings}
                            selectedItem={selectedItem}
                            getStyleCell={(cell, cells) => getStyleCell(cell, cells, DocumentType.revaluation)}
                            onSelect={(row) => setSelectedItem(row)}
                            onColumnEnter={(value: IChangeDataGrid) => {
                                clearTimer(() => calcRow(value))
                            }}
                            onChangeData={(value: IChangeDataGrid) => {
                                setTimer(() => calcRow(value))
                            }}
                            onDoubleClick={(row) => props.onDoubleClick?.(row)}
                            onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                            onFilterDelete={(i) => {
                                dispatchGridFilter({
                                    type: "deleteColumnFilter",
                                    payload: i.propertyName,
                                });
                            }}
                            onPageNumberChange={(n) => {
                                dispatchGridFilter({
                                    type: "changePageNumber",
                                    payload: { pageNumber: n },
                                });
                            }}
                            onNumberPerPageChange={(n) => {
                                dispatchGridFilter({
                                    type: "changeNumberPerPage",
                                    payload: { numberPerPage: n },
                                });
                            }}
                            searching
                            autoSelectFirst
                            customKizControl={(item: IChangeableGridRow) => {

                                if (!requiredScanKiz) return true;

                                const countKizScan: number = item.countKizScan;
                                const quantity: number = item?.quantity;
                                const numerator: number = item.numerator;
                                const denominator: number = item.denominator;

                                if (numerator < denominator) {
                                    if (countKizScan !== 1) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                } else {
                                    if ((countKizScan !== quantity)) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                }
                            }}
                        />
                    </div>
                    <Accordion opened={false} caption="" id={`accompanyingInvoiceInfo-${uuidv4()}`} bold documentSticky>
                        <GridWrapper cols={3}>
                            <MoneyFormatComponent inline disabled labelClassName="label__width-111" label={baseT("supplierAmounts")} inputId={"inputAccompanyingNdsSum"} value={sum.amountSupplierSum} />
                            <MoneyFormatComponent inline disabled labelClassName="label__width-111" label={baseT("supplierVatAmounts")} inputId={"inputAccompanyingNdsProviderSum"} value={sum.amountSupplierVatSum} />
                            <MoneyFormatComponent inline disabled label={baseT("supplierAmountsWithVat")} inputId={"inputAccompanyingProviderSum"} value={sum.amountSupplierSumIncVat} />
                        </GridWrapper>

                        <GridWrapper cols={3}>
                            <MoneyFormatComponent inline disabled labelClassName="label__width-111" label={baseT("retailAmount")} inputId={"inputAccompanyingRetailSumBNds"} value={sum.amountRetailSum} />
                            <MoneyFormatComponent inline disabled labelClassName="label__width-111" label={baseT("retailVatAmount")} inputId={"inputAccompanyingNdsRetailSumNds"} value={sum.amountRetailVatSum} />
                            <MoneyFormatComponent inline disabled label={baseT("retailAmountWithVat")} inputId={"inputAccompanyingRetailSum"} value={sum.amountRetailSumIncVat} />
                        </GridWrapper>
                    </Accordion>
                </div>
            </div>

            {creatorItem.lot && creatorItem.show && creatorItem?.editItem === null && (
                <ActRevaluationItemCreateModal
                    idGlobal={uuidv4()}
                    idDocument={data.idGlobal as string}
                    items={data.items}
                    searchOption={searchOption.value}
                    pricingModelId={data.idPricingModelGlobal}
                    scanData={scanData}
                    revaluationLot={creatorItem.lot}
                    ok={(createItem: ICreateItem) => {
                        operativeReserve.send(
                            {
                                idLot: createItem.item.idLotGlobal,
                                idDocument: data.idGlobal as string,
                                idTable: IdTableVariant.ActRevaluation2,
                                idDocumentItem: createItem.item.idGlobal,
                                quantity: createItem.item.quantity,
                            },
                            () => {
                                let filteredItems: IActRevaluationItemCreateDTO[] = data.items.filter((x) => x.idLotGlobal !== createItem.item.idLotGlobal);
                                let filteredDisplayItems: IDisplayItem[] = displayItems.filter((x) => x.idLotGlobal !== createItem.item.idLotGlobal);
                                setData({ ...data, items: [...filteredItems, createItem.item] });
                                setDisplayItems([...filteredDisplayItems, {...createItem.displayItem, isKiz: createItem.item.isKiz as boolean}]);
                                setCreatorItem({ lot: null, show: false, editItem: null });
                                setBaseFields({ ...baseFields, storeFromLot: creatorItem.lot?.store as IEntitySimpleDTO });

                                setItemsValidation([...itemsValidation, { err: false, message: "", idGlobal: createItem.item.idGlobal }]);
                                lotDP.remain(createItem.item.idLotGlobal, props.idGlobal ?? data.idGlobal as string, (response) => {
                                    setItemsFilter([
                                        ...itemsFilter,
                                        {
                                            idItem: createItem.item.idGlobal,
                                            quantityMax: response,
                                            quantityMin: 0,
                                        },
                                    ]);
                                });
                            }
                        );
                    }}
                    cancel={() => setCreatorItem({ lot: null, show: false, editItem: null })}
                />
            )}

            {creatorItem.lot && creatorItem.show && creatorItem?.editItem && (
                <ActRevaluationItemUpdateModal
                    idDocument={data.idGlobal as string}
                    pricingModelId={data.idPricingModelGlobal}
                    pricingModel={pricingModelDto}
                    lot={creatorItem.lot}
                    kizCount={displayItems.find((x) => x.idGlobal === selectedItem?.idGlobal)?.countKizScan as number}
                    editItem={creatorItem.editItem}
                    ok={(createItem: ICreateItem) => {
                        operativeReserve.send(
                            {
                                idLot: createItem.item.idLotGlobal,
                                idTable: IdTableVariant.ActRevaluation2,
                                idDocument: data.idGlobal as string,
                                idDocumentItem: createItem.item.idGlobal,
                                quantity: createItem.item.quantity,
                            },
                            () => {
                                setData({ ...data, items: [...data.items.filter((x) => x.idGlobal !== createItem.item.idGlobal), createItem.item] });
                                setDisplayItems([...displayItems.filter((x) => x.idGlobal !== createItem.displayItem.idGlobal), {...createItem.displayItem, isKiz: createItem.item.isKiz as boolean}]);
                                setCreatorItem({ lot: null, show: false, editItem: null });
                                setBaseFields({ ...baseFields, storeFromLot: creatorItem.lot?.store as IEntitySimpleDTO });
                            }
                        );
                    }}
                    cancel={() => setCreatorItem({ lot: null, show: false, editItem: null })}
                />
            )}

            {showKizScan && selectedScalingRatio && (
                <KizScanModal
                    ok={(value, scalingRatio: IScalingRatioDTO) => {
                        let items = data.items.filter((x) => x.idGlobal !== value.idGlobal);
                        setData({ ...data, items: items ? [...items, {...value, dateCreated: DateTime.now()}] : [value] });
                        setDisplayItems(
                            displayItems.map((x): IDisplayItem => {
                                return {
                                    countKizScan: x.idGlobal === value.idGlobal ? countKizSum(value) : x.countKizScan,
                                    goodsName: x.goodsName,
                                    idGlobal: x.idGlobal,
                                    goodsCode: x.goodsCode,
                                    producer: x.producer,
                                    retailAdpriceOld: x.retailAdpriceOld,
                                    retailPriceIncVatOld: x.retailPriceIncVatOld,
                                    retailAdprice: x.retailAdprice,
                                    idLotGlobal: x.idLotGlobal,
                                    isKiz: x.isKiz,
                                    quantity: x.quantity,
                                    isGnvls: x.isGnvls,
                                    retailPriceIncVat: x.retailPriceIncVat,
                                    retailSumIncVat: x.retailSumIncVat,
                                    storeName: x.storeName,
                                    dateCreated: x.idGlobal === value.idGlobal ? DateTime.now() : x.dateCreated,
                                    isOsu: x.isOsu,
                                };
                            })
                        );
                        setShowKizScan(false);
                    }}
                    cancel={() => setShowKizScan(false)}
                    selectedItem={selectedItemCreateDto as IActRevaluationItemCreateDTO}
                    document={{ idTable: IdTableVariant.ActRevaluation2, idDocument: data.idGlobal as string }}
                    idLotFrom={selectedItemCreateDto?.idLotGlobal ?? null}
                    numerator={selectedScalingRatio.numerator}
                    documentType={DocumentType.revaluation}
                    scalingRatio={selectedScalingRatio}
                />
            )}

            { /* При подборе товара используется LotsSelectorModal!*/ }
            {lotsViewItem.item && lotsViewItem.show && (
                <LotsSimpleSelectorModal
                    ok={(value_: IEntitySimpleDTO) => {
                        lotDP.getById(value_.idGlobal, (entity) => {
                            setCreatorItem({ lot: entity, show: true, editItem: null });
                        });
                    }}
                    cancel={() => {
                        setLotsViewItem({ item: lotsViewItem.item, show: false, multiple: true })
                    }
                    }
                    data={lotsViewItem.item}
                />
            )}

            {showMessageModal.show && (
                <MessageModalWindow
                    message={showMessageModal.message}
                    ok={{
                        onClick: () => {
                            setShowMessageModal({ show: false, message: "" });
                            showMessageModal.btSaveOrOk === "ok" ? onOkAction() : props.save(data);
                        },
                    }}
                    cancel={{
                        onClick: () => {
                            setShowMessageModal({ show: false, message: "" });
                        },
                    }}
                    primary
                />
            )}

            {showMessageModalValidDocument.show && (
                <MessageModalWindow
                    message={showMessageModalValidDocument.message}
                    ok={{
                        onClick: () => {
                            setShowMessageModalValidDocument({ show: false, message: "" });
                        },
                    }}
                    cancel={{ onClick: () => setShowMessageModalValidDocument({ show: false, message: "" }) }}
                />
            )}

            {showMessageModalValidBaseDocument && 
                <MessageModalWindow
                    message={t("errors.noStoreForBaseDocument")}
                    ok={{ onClick: () => setShowMessageModalValidBaseDocument(false) }}
                    cancel={{ onClick: () => setShowMessageModalValidBaseDocument(false) }}
                />
            }

            {selectBaseDocument && (
                <SelectDocumentModalWindow
                    idStoreGlobal={data.idStoreGlobal ?? uuidNull}
                    dateDocument={data.documentDate}
                    ok={(lots, document) => {
                        const values: IReturnCreatedItem[] = lots.map((x) => {
                            const idGlobal: string = uuidv4();
                            return {
                                displayItem: {
                                    idGlobal: idGlobal,
                                    goodsName: x.goods.displayName,
                                    storeName: x.store.displayName,
                                    goodsCode: x.goodsCode,
                                    retailAdpriceOld: x.retailCostInfo.adprice,
                                    retailPriceIncVatOld: x.retailCostInfo.priceIncVat,
                                    retailAdprice: x.retailCostInfo.adprice,
                                    producer: x.producer?.displayName,
                                    idLotGlobal: x.idGlobal,
                                    retailPriceIncVat: x.retailCostInfo?.priceIncVat ?? 0,
                                    retailSumIncVat: x.retailCostInfo?.sumIncVat ?? 0,
                                    quantity: x.quantityRem,
                                    isKiz: x.isKizFlag,
                                    isGnvls: false,
                                    countKizScan: x.isKiz === false ? undefined : 0,
                                    dateCreated: DateTime.now(),
                                    isOsu: x.kizOsuDto?.barcode !== undefined
                                },
                                createdItem: {
                                    idGlobal: idGlobal,
                                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                                    goodsCode: x.goodsCode,
                                    producer: x.producer?.displayName,
                                    idLotGlobal: x.idGlobal,
                                    retailCostInfo: x.retailCostInfo,
                                    supplierCostInfo: x.supplierCostInfo,
                                    retailAdprice: x.productMargin ?? 0,
                                    retailVat: x.retailCostInfo?.vat ?? 0,
                                    quantity: x.quantityRem ?? 0,
                                    retailPrice: x.retailCostInfo?.price,
                                    retailPriceVat: x.retailCostInfo?.priceIncVat ?? 0,
                                    retailSum: x.retailCostInfo?.sum ?? 0,
                                    retailVatSum: x.retailCostInfo?.vatSum ?? 0,
                                    retailSumVat: x.retailCostInfo?.sumIncVat ?? 0,
                                    producerPrice: x.producerPrice,
                                    retailAdpriceOld: x.retailCostInfo.adprice,
                                    retailPriceIncVatOld: x.retailCostInfo.priceIncVat,
                                    supplierAdprice: 0,
                                    isKiz: x.isKiz,
                                    kizs: [],
                                    kizBoxes: [],
                                    idGoodsGlobal: x.goods.idGlobal,
                                    idScalingRatioGlobal: x.scalingRatio.idGlobal,
                                    comment: "",
                                    dateCreated: DateTime.now(),
                                    isOsu: x?.kizOsuDto?.barcode !== undefined,
                                    kizOsuDto: x?.kizOsuDto
                                },
                            };
                        });
                        setDisplayNameBaseDoc(document.displayName);
                        setDisplayItems(values.map((x) => x.displayItem));
                        setData({ ...data, items: values.map((x) => x.createdItem) });
                        setSelectBaseDocument(false);
                    }}
                    cancel={{ onClick: () => setSelectBaseDocument(false) }}
                />
            )}
            {modalWindow}
        </BaseDocumentCreator>
    );
};

export default ActRevaluationForm;
